import { IClub } from "./club.model";
import { Court } from "./court.model";
import { UserModel } from "./user.model";

export class Team {
    team_id: number = 0;
    club_id: number = 0;
    league_id: number = 0;
    team_name: string = '';
    court_id: number = 0;
    points: number = 0;
    rating: number = 0;
}

export class LeagueTeam extends Team {
    court_name!: string;
    user_id!: number;
}

export class TeamDoubles extends Team {
    player1!: number;
    player2!: number;
}

export class standingDetail {
    team_id!: number;
    team_name!: string;
    average_point!: any;
    average_rating!: any;
}

export interface ITeam {
    id: number;
    size: number;
    name: string;
    gender:string;
    court: Court;
    rating: number;
    createdBy: string;
    noOfMembers: number;
    noOfLeagues: number;
    winPercentage: number;
    captain: UserModel;
    captain2: UserModel;
    club: IClub;
    points?: number;
    members: UserModel[];
}

export interface IPlayerDetails {
    userId: number;
    playerName: string;
    noOfMatches: number;
    noOfLeagues: number;
    win: number;
}

export interface ITeamDetails {
    teamId: number;
    teamName: string;
    courtName:string;
    CourtId:number;
    gender:string;
    rating:number;
    playerDetails: IPlayerDetails[];
    leagueDetails: any[];
}
